import { MobileOrDesktop } from '@repo/utils/deviceType/types';
import {
  CALCULATOR_SECTION_COPY,
  CD_RATES_DISCLAIMER_DIALOG_MAX_WIDTH,
} from '../constants';
import type { CalculatorSectionVariant } from '../types';
import { CalculatorDisclaimerContent } from './CalculatorDisclaimerContent';
import { CalculatorDisclaimerTitle } from './CalculatorDisclaimerTitle';
import { DisclosurePopup } from './DisclosurePopup';

type CalculatorDisclaimerProps = {
  deviceType?: MobileOrDesktop;
  variant?: CalculatorSectionVariant;
};

export function CalculatorDisclaimer({
  deviceType = 'desktop',
  variant = 'compound',
}: CalculatorDisclaimerProps) {
  const copy = CALCULATOR_SECTION_COPY[variant];

  return (
    <DisclosurePopup
      title={<CalculatorDisclaimerTitle />}
      content={<CalculatorDisclaimerContent body={copy.disclaimerPopupBody} />}
      deviceType={deviceType}
      paperMaxWidth={variant === 'cdRates' ? CD_RATES_DISCLAIMER_DIALOG_MAX_WIDTH : undefined}
    />
  );
}
